import i18n from '@/i18n'

/**
 * Dynamically translates an array of strings
 * Tries to find each string translation as value in translations
 * If found, return translation, otherwise returns original string as fallback
 * @param arrayOfStrings
 * @returns {(string|VueI18n.LocaleMessages|*)[]|*[]}
 */
export function getTranslationsFromArrayOfString(arrayOfStrings) {
  if (!arrayOfStrings) {
    console.error('No content provided')
    return []
  }

  return Object.keys(arrayOfStrings).map((key) => {
    // Check if the column value exists as a value in the translations
    const translationKey = findTranslationKey(arrayOfStrings[key])

    // If translation key is found, use it, otherwise fallback to the original value
    return translationKey ? i18n.t(translationKey) : arrayOfStrings[key]
  })
}

/**
 * Search for the matching value in i18n.fr.json
 * If found, return the matching key (e.g. i18n.t('matching_key')
 * Otherwise returns null
 * @param value
 * @returns {null|string}
 */
export function findTranslationKey(value) {
  // Loop through all entries in the flat translation JSON to find the value
  // We consider i18n.fr.json to be the default translation file
  for (const [key, val] of Object.entries(i18n.messages.fr)) {
    if (val === value) {
      return key
    }
  }
  return null
}
